import BetaRobot from 'app/src/engine/movable-items/BetaRobot';
import MovableItem from 'app/src/engine/movable-items/MovableItem';
import BetaRobotNode from 'app/src/game/map/movable-items/BetaRobotNode';
import GamePlugin, { MovableItemData } from 'app/src/plugins/GamePlugin';
import * as React from 'react';

export default class RobotsGamePlugin extends GamePlugin {
	// Get a list of MovableItems that this plugin provides. When the game
	// state is being initialized, it'll ask all plugins which MovableItems
	// they create, and later use those corresponding plugins to build
	// MovableItems.
	public getListOfProvidedMovableItems(): string[] {
		return ['BetaRobot'];
	}

	// Based on MovableItem data, generate a MovableItems.
	public getMovableItem(data: MovableItemData): MovableItem {
		const id = data['id'];

		if (typeof id !== 'string') {
			throw new Error('Missing id in description');
		}

		return new BetaRobot(id);
	}

	// Given a MovableItem, is this plugin capable of generating a corresponding
	// MovableItemNode?
	public providesNodeForMovableItem(movableItem: MovableItem): boolean {
		let providesNode = false;

		if (movableItem instanceof BetaRobot) {
			providesNode = true;
		}

		return providesNode;
	}

	// Based on a MovableItem, generate a MovableItemNode.
	public getMovableItemNode(movableItem: MovableItem): React.ReactElement {
		return <BetaRobotNode key={'MovableItem--' + movableItem.id} />;
	}
}
